/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ContentItemProperties } from '@/data/types/Slot';

const contentItems: ContentItemProperties[] = [
    { emsName: '_CS_Header_Espot' },
    { emsName: '_CS_Footer_Espot' }
];
export default contentItems;
